import React, { useState, useContext, useEffect } from 'react'

import { Form, Input, Modal, Tabs } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { displayMessage } from '../../helpers/messages'
import api from '../../services/api'
import styles from '../../services/styles'
import SL_Button from '../../components/buttons/Button';
import { CloseCircleOutlined, EditTwoTone, ExclamationCircleOutlined, LeftCircleTwoTone, SaveFilled } from '@ant-design/icons'
import { idID } from '@mui/material/locale'
import UpdatePassword from './UpdatePassword'
import EUsersTypes from '../../enums/EUsersTypes';

const { tc1 } = styles

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function DetailProfile(props) {
    const { mobile_mode } = useContext(GeneralContext)

    const { mustChnagePassword } = props
    const [userData, setUserData] = useState(null)
    const [readOnly, setReadOnly] = useState(true)
    const [changingPassword, setchangingPassword] = useState(false)
    const [formRef] = Form.useForm()
    const [formRefPassword] = Form.useForm()


    const {
        setShowLoading, loggedUser
    } = useContext(GeneralContext)


    useEffect(() => {
        //tela tbm é o detalhe do usuario logado
        const user = loggedUser
        if (user) {
            setUserData(user)
            formRef.setFieldsValue(user)
        }
    }, [props.user])

    const saveUpdateUser = (values) => {

        setShowLoading(true)
        const payload = { id: userData.id, type: EUsersTypes.PANEL_ADMIN.code, ...values }

        api.user.update(payload)
            .then(
                rs => {
                    alert(displayMessage('UPDATE_USER_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    setUserData(rs.data)
                    setReadOnly(true)

                }
            ).finally(
                () => {
                    setShowLoading(false)
                }
            )
    }

    const saveUpdatePassword = (values) => {
        setShowLoading(true)
        const payload = { ...values }
        api.auth.changePassword(payload)
            .then(
                rs => {
                    alert(displayMessage('UPDATE_USER_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    setUserData(rs.data)
                    setchangingPassword(false)

                    formRefPassword.resetFields()

                }
            ).finally(
                () => {
                    setShowLoading(false)
                }
            )
    }

    const handleOnEditar = () => {
        if (readOnly) {
            setReadOnly(current => !current)
        } else {
            formRef.submit()
        }
    }
    const handleOnChangePassword = () => {
        if (!changingPassword) {
            setchangingPassword(current => !current)
        } else {
            formRefPassword.submit()
        }
    }

    return (
        <div className={`w-full flex flex-col gap-2`}>
            <div className='font-bold text-lg text-appian-blue text-center'>{displayMessage('PERSONAL_DATA')}</div>
            <Form
                className='w-full flex flex-col p-5'
                style={{maxWidth: mobile_mode ? '80%' : '50%'}}
                onFinish={saveUpdateUser}
                layout="vertical"
                requiredMark='optional'
                initialValues={userData}
                disabled={readOnly}
                form={formRef}
            >

                <Form.Item
                    label={displayMessage('FIRST_NAME')}
                    name="first_name"
                    className={`w-full flex-col`}
                    rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('FIRST_NAME')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('LAST_NAME')}
                    name="last_name"
                    className={`w-full flex-col`}
                    rules={[{ required: false, message: displayMessage('FULL_NAME_MANDATORY') }]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('LAST_NAME')}
                        className={inputsClassName}

                    />
                </Form.Item>

                <div className='flex flex-col'>


                    <Form.Item
                        label={displayMessage('EMAIL')}
                        name="email"
                        className={`w-full flex-col`}
                        rules={[{ required: true, type: 'email', message: displayMessage('INVALID_EMAIL') }]}
                    >
                        <Input
                            type="text"
                            size='large'
                            placeholder={displayMessage('EMAIL')}
                            className={inputsClassName}
                            disabled
                        />
                    </Form.Item>
                </div>
            </Form>
            <div className='flex w-full justify-end gap-2'>
                {!readOnly &&
                    <SL_Button
                        icon={<CloseCircleOutlined color={tc1} />}
                        size='large'
                        onClick={() => setReadOnly(true)}
                        className="border-appian-grey text-appian-blue bg-appian-grey max-h-9 text-base align self-end"
                    >
                        {displayMessage('CANCEL')}
                    </SL_Button>
                }
                <SL_Button
                    icon={<EditTwoTone twoToneColor="white" />}
                    size='large'
                    onClick={handleOnEditar}
                    className="border-appian-blue max-h-9 text-base align self-end"
                >
                    {readOnly ? displayMessage('EDIT') : displayMessage('SAVE')}
                </SL_Button>
            </div>

            <Tabs style={{ marginTop: '20Px' }} />

            <div className='font-bold text-lg text-appian-blue text-center'>{displayMessage('CHANGE_PASSWORD')}</div>

            <Form
                className='w-full flex flex-col p-5'
                style={{maxWidth: mobile_mode ? '80%' : '50%'}}
                onFinish={saveUpdatePassword}
                layout="vertical"
                requiredMark='optional'
                initialValues={userData}
                disabled={!changingPassword}
                form={formRefPassword}
            >
                <UpdatePassword changingPassword={changingPassword} userData={userData} />

            </Form>


            <div className='flex w-full justify-end gap-2'>
                {changingPassword &&
                    <SL_Button
                        icon={<CloseCircleOutlined color={tc1} />}
                        size='large'
                        onClick={() => {
                            setchangingPassword(false)
                            formRefPassword.resetFields()
                        }}
                        className="border-appian-grey text-appian-blue bg-appian-grey max-h-9 text-base align self-end"
                    >
                        {displayMessage('CANCEL')}
                    </SL_Button>
                }
                <SL_Button
                    icon={<EditTwoTone twoToneColor="white" />}
                    size='large'
                    onClick={handleOnChangePassword}
                    className="border-appian-blue max-h-9 text-base align self-end"
                >
                    {!changingPassword ? displayMessage('REDEFINE_PASSWORD') : displayMessage('SAVE')}
                </SL_Button>
            </div>
        </div>
    )
}